import apiClient from "../../api/apiClient";

export interface DashboardStats {
    cards?: {
        total_companies?: number;
        total_users?: number;
        total_chatbots?: number;
        total_tokens?: number;
        total_clients?: number;
        total_managed_chatbots?: number;
        total_agency_users?: number;
        total_company_users?: number;
        total_conversations?: number;
        active_chatbots?: number;
        [key: string]: any;
    };
    recent_companies?: Array<{
        id: number;
        name: string;
        type: string;
        created_at: string;
    }>;
    client_activity?: Array<{
        name: string;
        count: number;
    }>;
    recent_conversations?: Array<{
        id: number;
        bot_name: string;
        session_id: string;
        created_at: string;
    }>;
    [key: string]: any;
}

const dashboardService = {
    getDashboardStats: async (): Promise<DashboardStats> => {
        const response = await apiClient.get<DashboardStats>("/dashboard/stats");
        return response;
    },
};

export default dashboardService;
